type NormalizedBusinessStatus = '01' | '02' | '03';

const STATUS_MAP: Record<NormalizedBusinessStatus, { label: string; className: string }> = {
  '01': { label: '영업 중', className: 'bg-emerald-100 text-emerald-800' },
  '02': { label: '휴업', className: 'bg-amber-100 text-amber-800' },
  '03': { label: '폐업', className: 'bg-red-100 text-red-800' },
};

function normalizeBusinessStatusCode(value: string): NormalizedBusinessStatus | null {
  const trimmed = value.trim();
  if (trimmed === '01' || trimmed === '02' || trimmed === '03') return trimmed;
  if (trimmed === 'ACTIVE') return '01';
  if (trimmed === 'SUSPENDED') return '02';
  if (trimmed === 'CLOSED') return '03';
  return null;
}

export function BusinessStatusBadge({ value }: { value: string | null | undefined }) {
  if (!value) return <span className="text-gray-400">-</span>;

  const code = normalizeBusinessStatusCode(value);
  if (!code) return <span className="text-gray-500">{value}</span>;

  const meta = STATUS_MAP[code];
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${meta.className}`}
    >
      {meta.label}
    </span>
  );
}
